import Highway from '@dogstudio/highway';
import createEventMap from '../modules/event-map.js';

export default class pageEventsMapRenderer extends Highway.Renderer {
    onEnter() {
        this.mapInteractive = createEventMap('page-events-map-data', this.wrap.lastElementChild);
    }

    onLeave() {
        if (this.mapInteractive) {
            this.mapInteractive.remove();
            this.mapInteractive = null;
        }
    }
}
